module.exports = __webpack_public_path__ + "static/scale-model-of-nevada-historical-society-in-reno-nevada-080b1589e556dee8d32a900053b8e0b4.png";